// tslint:disable: no-input-rename

import { ComponentRef, Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { Overlay, OverlayPositionBuilder, OverlayRef, ConnectedPosition, CloseScrollStrategy } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

import { TooltipContainer } from './tooltip-container.component';
import { TooltipContent } from './tooltip-content.type';

const positions = {
  top: {
    originX: 'center',
    originY: 'top',
    overlayX: 'center',
    overlayY: 'bottom',
    offsetY: -8,
  },
  right: {
    originX: 'end',
    originY: 'center',
    overlayX: 'start',
    overlayY: 'center',
    offsetX: 8,
  },
  bottom: {
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
    offsetY: 8,
  },
  left: {
    originX: 'start',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'center',
    offsetX: -8,
  }
};

@Directive({ selector: '[sukaTooltip]' })
export class Tooltip implements OnInit {
  private overlayRef: OverlayRef;
  private open = false;

  @Input('sukaTooltip') content: TooltipContent = '';
  @Input('tooltipTrigger') trigger: 'hover' | 'click' = 'hover';
  @Input('tooltipPosition') position: 'top' | 'bottom' | 'left' | 'right' = 'bottom';
  @Input('tooltipDuration') duration: number;

  constructor(private overlay: Overlay,
              private overlayPositionBuilder: OverlayPositionBuilder,
              private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    const positionStrategy = this.overlayPositionBuilder
      .flexibleConnectedTo(this.elementRef)
      .withPositions([ positions[this.position] as ConnectedPosition]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close(),
    });
  }

  private show() {
    this.open = true;
    const tooltipRef: ComponentRef<TooltipContainer>
      = this.overlayRef.attach(new ComponentPortal(TooltipContainer));

    tooltipRef.instance.content = this.content;
    tooltipRef.instance.position = this.position;
  }

  private hide() {
    this.open = false;
    this.overlayRef.detach();
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    if (this.trigger === 'hover') {
      this.show();
    }
  }

  @HostListener('mouseout')
  onMouseOut() {
    if (this.trigger === 'hover') {
      this.hide();
    }
  }

  @HostListener('click')
  onClick() {
    if (this.trigger === 'click') {
      this.open ? this.hide() : this.show();

      if (this.duration) {
        setTimeout(() => {
          this.hide();
        }, this.duration);
      }
    }
  }
}
